

import { createReducer, on } from "@ngrx/store";
import { allApiLinks, loginDetails, otpVerifiedDetails, userDetails, businessDetails, usersList, selectedUser, localLanguage, permissionData, dashboardDetails, tempararyAddUserFormData } from "./auth.actions";
import { initialAuthState } from "./auth.state";


const _authReducer = createReducer(
    initialAuthState,
    on(loginDetails, (state: any, action) => {
        return {
            ...state,
            loginDetails: action.logindata
        }
    }),
    on(otpVerifiedDetails, (state: any, action) => {
        return {
            ...state,
            otpVerifiedDetails: action.otpVerfiedData
        }
    }),
    on(userDetails, (state: any, { data }) => {
        return {
            ...state,
            userDetails: data
        }
    }),
    on(localLanguage, (state: any, { language }) => {
        return {
            ...state,
            localLanguage: language
        }
    }),
    on(businessDetails, (state: any, { data }) => {
        return {
            ...state,
            businessDetails: data
        }
    }),
    on(allApiLinks, (state: any, action) => {
        return {
            ...state,
            allApiLinks: action.data
        }
    }),
    on(usersList, (state: any, action) => {
        return {
            ...state,
            usersList: action.users
        }
    }),
    on(selectedUser, (state: any, action) => {
        return {
            ...state,
            selectedUser: action.selectedUser
        }
    }),

    on(permissionData, (state: any, action) => {
        return {
            ...state,
            permissionData: action.permissionData
        }
    }),

    on(dashboardDetails, (state: any, action) => {
        return {
            ...state,
            dashboardDetails: action.dashboardDetails
        }
    }),

    on(tempararyAddUserFormData, (state: any, action) => {
        return {
            ...state,
            tempararyAddUserFormData: action.tempararyAddUserFormData
        }
    })

)

export function authReducer(state: any, action: any) {
    return _authReducer(state, action)
}
